export class CampaignDetail extends HTMLElement {
  constructor(campaign_id, is_admin) {
    super();
    this.id = "details_"+campaign_id||'';
    this.campaign_id = campaign_id;
    this._is_admin = is_admin;
  }

  async connectedCallback() {
    this.innerHTML = `Loading...`;
    let res = await fetch(`/admin/campaigns/${this.campaign_id}/detail`);
    let json = await res.json();
    this._data = json.data;
    this._meta = json.meta;
    let discLanguage = this._data.call_disclaimer == 1 ? 'English' :
                        this._data.call_disclaimer == 2 ? 'Spanish' :
                        this._data.call_disclaimer == 3 ? 'French' : 'None';

    this._data.webhooks = this._data.webhooks || []  // Ideally we can do away with this line. MT needs a fix.
    let webhooks = this._data.webhooks.map(webhook => `<div class="col-sm-6"><p>Name: ${webhook.webhook}</p></div><div class="col-sm-6"><p>Timing: ${webhook.action_timing == 1 ? 'Beginning of call' : 'End of call'}</p></div>`).join('')
    this.innerHTML = 
      `
      <style>
        .campaign-detail-main {
          padding: 20px;
        }

        campaign-detail {
          overflow-wrap: break-word;
        }

        campaign-detail>.row>div:first-child {
          border-right: 1px solid #CCCCCC
        }

        campaign-detail>.row>div {
          padding-left: 60px !important;
        }

        campaign-detail p {
          font-weight: 600;
        }

        .campaign-detail-highlight {
          color: #337AB7;
        }

        .campaign-detail-row span {
          display: inline-block;
          width: 49%;
        }
      </style>

      <div class="row campaign-detail-main">
        <div class="col-sm-2">
          <p>Created on: ${this._data.created_at.slice(0, 10)||''}</p>
          <p>By: ${this._meta.creator||''}</p>
          <p>Changes: ${this._meta.audits||0}</p>
          <p>7 Day Call Count: ${this._meta.recent_call_count||0}</p>
        </div>
        <div class="col-sm-4 campaign-detail-highlight">
          <div class="col-sm-12 no-gutters campaign-detail-row">
            <span><p>Call Recording:</p></span>
            <span><p data-cy="detail-call-rec">${this._data.enable_call_recording ? 'On' : 'Off'}</p></span>
          </div>
          <div class="col-sm-12 no-gutters campaign-detail-row">
            <span><p>Recording Announcement Language:</p></span>
            <span><p data-cy="detail-disc-lang">${discLanguage}</p></span>
          </div>
          <div class="col-sm-12 no-gutters campaign-detail-row">
            <span><p>CallShield:</p></span>
            <span><p data-cy="detail-call-shield">${this._data.callshield ? 'On' : 'Off'}</p></span>
          </div>
          ${this._is_admin ? 
            `<div class="col-sm-12 no-gutters campaign-detail-row">
                <span><p>LeadScore:</p></span>
                <span><p data-cy="detail-lead-score">${this._data.call_processing_map ? 'On' : 'Off'}</p></span>
              </div>` 
            : ''}
          ${this._data.target_id ? 
            `<div class="col-sm-12 no-gutters campaign-detail-row">
                <span><p>Call Treatment:</p></span>
                <span><p data-cy="detail-call-treat">${this._data.target.target_name}</p></span>
              </div>` 
            : ''}
          ${this._data.consumer_greeting_name ? 
            `<div class="col-sm-12 no-gutters campaign-detail-row">
                <span><p>Consumer Greeting:</p></span>
                <span><p data-cy="detail-consumer-greet">${this._data.consumer_greeting_name}</p></span>
              </div>` 
            : ''}
          ${this._data.sales_rep_whisper_name ? 
            `<div class="col-sm-12 no-gutters campaign-detail-row">
                <span><p>Sales Rep Whisper:</p></span>
                <span><p data-cy="detail-sales-rep">${this._data.sales_rep_whisper_name}</p></span>
              </div>` 
            : ''}
          </div>
        <div class="col-sm-6">
          ${this._data.webhooks.length > 0 && !this._data.target_id ? `<p class="campaign-detail-highlight">Webhooks</p><div class="row webhook-details" data-cy="webhook-details">${webhooks}</div>` : ''}
        </div>
      </div>
      `;
  }
}

customElements.define('campaign-detail', CampaignDetail)